<template>
  <BasePage title="Colleagues">
    <div class="columns">
      <div class="column is-half-desktop is-offset-one-quarter-desktop">
        <LinkTabs :tabs="tabs"/>

        <slot></slot>

      </div>
    </div>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import LinkTabs from './LinkTabs'
import store from '../store'

export default {
  name: 'Colleagues',
  components: {
    BasePage,
    LinkTabs,
  },
  computed: {
    colleagueCount () {
      return store.state.user.colleagues.length
    }
  },
  data () {
    return {
      tabs: [
        {
          to: '/colleagues',
          title: 'My Colleagues',
          count: this.colleagueCount,
        },
        {
          to: '/colleagues/find',
          title: 'Find Colleagues',
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Colleagues.vue?53acf804